import React from 'react'

import { Button } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'

import { useSearchParams } from '@edge/spark/utils'
import { DashboardNameDialog, type Props as DashboardNameDialogProps } from '../DashboardNameDialog'
import { useCreateDashboardMutation } from '@edge/spark/io-dashboards'

interface DashboardButtonProps {
    disabled?: boolean
    initialValue?: string
    onSubmit?: () => void
}

export const AddDashboardButton: React.FC<DashboardButtonProps> = ({
    disabled,
    initialValue,
    onSubmit,
}: DashboardButtonProps) => {
    const [open, setOpen] = React.useState(false)
    const [addDashboard] = useCreateDashboardMutation()
    const { uid: userId } = useSearchParams()

    const handleClose = (): void => setOpen(false)
    const handleClickOpen = (): void => setOpen(true)
    const handleSubmit: DashboardNameDialogProps['onSubmit'] = ({ name }): void => {
        addDashboard({ variables: { name, userId } })
        onSubmit?.()
        handleClose()
    }

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={handleClickOpen}
                startIcon={<AddIcon />}
                disabled={disabled}
            >
                Dashboard
            </Button>
            {open && <DashboardNameDialog initialValue={initialValue} onClose={handleClose} onSubmit={handleSubmit} />}
        </>
    )
}
